<template>
  <span class="stage-tag" :style="{ background: cfg.color + '1a', color: cfg.color }">
    {{ cfg.text }}
  </span>
</template>

<script>
import { STAGE_LABELS } from '@/store/modules/trip'

export default {
  name: 'StageTag',
  props: {
    stage: { type: String, required: true }
  },
  computed: {
    cfg () {
      return STAGE_LABELS[this.stage] || STAGE_LABELS.planning
    }
  }
}
</script>

<style scoped>
.stage-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}
</style>
